import { Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import { useFormContext } from 'react-hook-form';
import { RedirectToAppButton } from '@/widgets/RedirectToAppButton';
import generateQuizResponse from '../lib/generateQuizResponse';

const FinalQuizStep = () => {
  const { t } = useTranslation();
  const { getValues } = useFormContext();

  const TEXT = generateQuizResponse(getValues(), t);

  return (
    <Flex
      alignSelf='center'
      flexDir='column'
      gap='xl'
      justifyContent='center'
      w={{ base: 'full', lg: 'container.lg' }}
    >
      <Text
        fontSize='lg'
        whiteSpace='pre-wrap'
      >
        {TEXT}
      </Text>
      <RedirectToAppButton
        alignSelf='center'
        buttonText={t('mainPage.finalQuizStep.startTrial')}
        dataLayer={{ event: 'quiz_start_trial' }}
        minW='3xs'
        pageName='signup'
        size='md'
        w='max-content'
      />
    </Flex>
  );
};

export default FinalQuizStep;
